import { Root } from '../pages'

export default function UnlocalizedRoot() {
  return <Root />
}
